import type { AxiosProgressEvent, AxiosResponse } from 'axios';

import api from '../utils/AxiosInterceptor';

export async function uploadFile(
  file: File,
  handleUploadProgress: (e: AxiosProgressEvent) => void
): Promise<AxiosResponse> {
  const body = new FormData();
  body.append('file', file);

  const response = await api.post(
    '/api/v1/solicitacoes/upload',
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: handleUploadProgress,
    }
  );

  return response;
}


export async function getDocuments(
  requestId: string
): Promise<AxiosResponse> {
  const response = await api.get(
    `/api/v1/solicitacoes/${requestId}/documentos`,
  );

  return response;
}

export async function getDocumentUrl(
  documentId: string,
): Promise<AxiosResponse> {
  const response = await api.get(
    `/api/v1/document-download-url/${documentId}`,
  );

  return response;
}

export async function signDocument(
  requestId: string, 
  documentId: string, 
  password: string
): Promise<AxiosResponse> {
  const response = await api.post(
    `/api/v1/solicitacoes/${requestId}/signatures/pades-electronic/${documentId}`, {
      hasWaterMark: true,
      userPassword: password
  })
  return response;
}

